import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import web5 from "../img/news.jpg";
import web1 from "../img/ltnews.jpg";
import "../style/styles.css";
import "../style/NewsSof.css";

const NewsSof = () => {
  let alText = "Photo News Paper";

  const quickStats = [
    { value: "News", label: "Circulation" },
    { value: "Ads", label: "Advertisement" },
    { value: "Stock", label: "Inventory" },
    { value: "A/c", label: "Accounts" },
  ];

  const keyModules = [
    {
      title: "Key features(Entry Module)",
      text:
        "Manage label printing, supplement label printing, road challan, daily changes reports, print order, monthly supply, bill statement, credit note, net circulation and return registers.",
    },
    {
      title: "Advertisement Reports",
      text:
        "Control display and classified advertisement billing, unbilled registers, client, agent, representative, sector, page, colour, ad type and size-wise reports.",
    },
    {
      title: "Accounting Reports",
      text:
        "Generate cash bank book, journal book, debit note, credit note, purchase, sales, ledger, trial balance, expense trial, profit and loss and outstanding reports.",
    },
    {
      title: "MIS Reports",
      text:
        "Review supplier-wise product purchase, monthly product purchase, department-wise store consumption and pending purchase order reports.",
    },
    {
      title: "Circulation Control",
      text:
        "Analyze daily supply, monthly supply, state-wise supply, salesman-wise supply, agent statement, net circulation and outstanding reports.",
    },
    {
      title: "Magazine / Newspaper Management",
      text:
        "Software for Daily News Paper /Fortnightly / Monthly Magazine,Cover with Circulation,Advertisement,Inventory,Accounts.",
    },
  ];

  const entryFeatures = [
    "Label Printing",
    "Suppliment Label Printing",
    "Road Challan",
    "Daily Changes Reports",
    "Sales Man Wise Daily Changes Reprots",
    "State Wise Supply Changes Reprts",
    "Daily Supply Report",
    "Print Order",
    "Suppliment-Print Order",
    "Monthly Print Order",
    "Non-Receipt Register",
    "Daily Supply Summary",
    "Monthly Supply Details",
    "State Wise Supply Details",
    "Sales Man Wise Supply Details/ Summary",
    "Discount Wise Despatch Summary",
    "Agent Wise Daily/Weekly/Monthly Statement of Despatch",
    "Date Wise Monthly Supply Register",
    "Monthly Bill Statement",
    "OutStation Monthly Bill Summary",
    "Credit note Register",
    "Net Circulation",
    "Supply Average Calculation",
    "Agent Wise Supply Averave Register",
    "Undristributed Register",
    "Complementary Register",
    "Unsold and Damage Return Register",
  ];

  const accountingReports = [
    "Cash Bank Book",
    "Journal Book",
    "Debit Note Register",
    "Credit Note Register",
    "Purchase Register",
    "Purchase Return Register",
    "Sales Register",
    "Sales Return Register",
    "Ledger",
    "Trial Balance",
    "Expense Trial",
    "Trading and Profit & Loss Statement",
    "Bank Reconciliation",
    "Interest Calculation",
    "Confirmation of Accounts",
    "Statement of Expenditure",
    "Circation Outstanding Reports",
    "Circulation Aging Analysis",
    "Sales Man Circulation Outstanding",
    "State Wise Circulation Outstanding",
    "Outstanding (NET CIRCULATION)",
    "Sales Man Wise Outstanding (NET CIRCULATION)",
    "State Wise Outstanding (NET CIRCULATION)",
    "District Wise Outstanding(NET CIRCULATION)",
  ];

  const stockReports = [
    "Publish Date Wise Bill Register",
    "Client & Publish Date Wise Bill Register",
    "Agent & Publish Date Wise Bill Register",
    "Ads. Bill Register(Display)",
    "Ads. Bill Register(Classified)",
    "Unbilledl Register",
    "Classified Unbilledl Register",
    "Cleint Wise Unbilled Register",
    "Agent Wise Unbilled Register",
    "Representative Wise Unbilled Register",
    "Client Name Wise Bill Register",
    "Agent Wise Bill Register",
    "Sales Representative Wise Bill Register",
    "Sector Wise Bill Register",
    "Display-Date Wise Advertisement Reports",
    "Display-Cleint Name Wise Query",
    "Display-Agent Name Wise Reports",
    "Colour Wise Report",
    "Display-Ad Type Wise Reports",
    "Display-Page Wise Reports",
    "Display-Ad.Size Wise Report",
    "Display-Representative Wise Report",
    "Classified Date Wise Advertisement Reports",
    "Classified Cleint Name Wise Classified Query",
    "Classified Agent Name Wise Reports",
    "Classified Category Wise Ads.",
    "Classified Representative Wise Ads.",
    "Details Ousting Reports",
    "Cash Memo Register",
    "Collection Register",
    "Oustanding Summary",
  ];

  const misReports = [
    "Supplier Wise Product Purchase Register",
    "Supplier Wise Monthly Product Purchase Report",
    "Department Wise Store Consumption Reports",
    "Pending Purchase Order Register",
  ];

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="newssof-detail-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          EBS Software Solution -Jewellery Outlet retail Software,Siliguri,West
          Bengal,India
        </title>
        <meta
          name="description"
          content="jewellery retail software | POS software for jewellery stores | jewellery store management software | Retail jewellery inventory system |jewellery point of sale system | jewellery POS solutions | jewellery retail POS software |jewellery store POS management |Retail management system for jewellery |jewellery sales software |jewellery POS and inventory control Point of sale for jewellery | business jewellery retail technology |jewellery store POS terminal jewellery |sales and inventory software |Retail software for jewellery outlets |jewellery shop software |jewellery cashier system Cloud-based POS for jewellery stores | Jewellery Karigar Software"
        />
      </Helmet>

      <section className="newssof-hero">
        <img
          className="newssof-hero-bg"
          src={web5}
          alt={alText}
          onError={handleImageError}
        />
        <div className="newssof-hero-overlay"></div>

        <Container className="newssof-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="newssof-hero-content">
                <div className="newssof-kicker">News Paper / Magazine Software</div>
                <h1>NewsPro</h1>
                <h2>
                  Software for Daily News Paper /Fortnightly / Monthly
                  Magazine,Cover with Circulation,Advertisement,Inventory,Accounts
                </h2>
                <p>
                  An Integrated controlling systems for Newspapers,maintaining
                  accounts for every-day newspapers circulations outstanding
                  analysis,inventory controlling and all these advertisement modules
                  reports,market selling reports and upcoming growths.
                </p>

                <div className="newssof-hero-actions">
                  <a href="#newssof-modules" className="newssof-btn newssof-btn-primary">
                    View Features
                  </a>
                  <Link to="/EmailContactForm" className="newssof-btn newssof-btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="newssof-highlight-card">
                <span>Integrated Newspaper Solution</span>
                <strong>Circulation + Advertisement + Inventory + Accounts</strong>
                <p>
                  Designed for daily newspapers, fortnightly publications and
                  monthly magazines with circulation and advertisement control.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="newssof-stats-section">
        <Container>
          <Row className="g-3">
            {quickStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="newssof-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="newssof-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="newssof-section-label">Overview</div>
              <h2 className="newssof-section-title">
                Newspaper circulation, advertisement and accounting management
              </h2>
              <p className="newssof-text">
                NewsPro is designed to manage newspaper circulation, advertisement,
                inventory and accounts with strong reporting support for daily
                operations, market selling reports, outstanding analysis and
                upcoming growths.
              </p>
              <p className="newssof-text">
                The system helps publication businesses maintain every-day
                newspaper circulation accounts, inventory control, advertisement
                reports and accounting reports from one organized platform.
              </p>
            </Col>

            <Col lg={6}>
              <div className="newssof-overview-card">
                <h3>NewsPro covers</h3>
                <div className="newssof-overview-grid">
                  <div><span>✓</span><p>Circulation</p></div>
                  <div><span>✓</span><p>Advertisement</p></div>
                  <div><span>✓</span><p>Inventory</p></div>
                  <div><span>✓</span><p>Accounts</p></div>
                  <div><span>✓</span><p>Outstanding</p></div>
                  <div><span>✓</span><p>MIS Reports</p></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="newssof-modules-section" id="newssof-modules">
        <Container>
          <div className="newssof-heading-center">
            <div className="newssof-section-label">Key Modules</div>
            <h2 className="newssof-section-title">
              Complete newspaper management workflow
            </h2>
            <p>
              NewsPro connects circulation, advertisement, inventory, MIS,
              outstanding and accounting reports in one professional publication
              management system.
            </p>
          </div>

          <Row className="g-4">
            {keyModules.map((module, index) => (
              <Col lg={4} md={6} key={module.title}>
                <div className="newssof-module-card">
                  <div className="newssof-module-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="newssof-feature-list-section">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="newssof-list-card">
                <div className="newssof-section-label">Entry Module</div>
                <h2>Key features(Entry Module)</h2>
                <ul>
                  {entryFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="newssof-list-card newssof-list-card-dark">
                <div className="newssof-section-label">Accounting Reports</div>
                <h2>Accounting Reports</h2>
                <ul>
                  {accountingReports.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="newssof-feature-list-section newssof-feature-list-alt">
        <Container>
          <Row className="g-4">
            <Col lg={7}>
              <div className="newssof-list-card">
                <div className="newssof-section-label">Stock Reports</div>
                <h2>Stock Reports</h2>
                <ul>
                  {stockReports.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={5}>
              <div className="newssof-side-stack">
                <div className="newssof-list-card">
                  <div className="newssof-section-label">MIS Reports</div>
                  <h2>MIS Reports</h2>
                  <ul>
                    {misReports.map((item) => (
                      <li key={item}><span>✓</span>{item}</li>
                    ))}
                  </ul>
                </div>

                <div className="newssof-image-card">
                  <img
                    src={web1}
                    alt={alText}
                    onError={handleImageError}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="newssof-cta-section">
        <Container>
          <div className="newssof-cta-card">
            <div>
              <span>Ready to manage newspaper operations professionally?</span>
              <h2>Use NewsPro for circulation, ads, inventory and accounts.</h2>
              <p>
                Get a complete publication management solution for daily
                newspapers, fortnightly publications and monthly magazines.
              </p>
            </div>
            <Link to="/EmailContactForm" className="newssof-btn newssof-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default NewsSof;
